import React, { useContext } from 'react'
import { MotorBikesContext } from '../../../../contexts/motorBikesContext'
import { ContextService } from '../../../../contexts/serviceGralContext'
import InputsElements from '../../../../elements/InputsElements'

function ResolutionInput() {

    const { newService } = useContext(MotorBikesContext)
    const { currentService, dinamicDataService, editDinamicServiceDataHandler } = useContext(ContextService)

    return (
        <>
            {
                dinamicDataService?.Status != "-1" ?
                    <InputsElements
                        label="Resolución"
                        name="Resolution"
                        value={dinamicDataService.Resolution ?? currentService?.Resolution ?? ''}
                        functEdit={e => editDinamicServiceDataHandler({ [e.target.name]: e.target.value })}
                        inputState={(!currentService?.Status != "-1" && !(!!newService.Status && newService.Status != "-1"))}
                    />
                    :
                    <InputsElements
                        label="Resolución"
                        name="Resolution"
                        value={currentService.Resolution ?? ''}
                        inputState={true}
                    />
            }
        </>
    )
}

export default React.memo(ResolutionInput)